import React from 'react';
import { Box } from '@mui/material';

import { TextField, ToggleButtonGroupField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { Category_Restrictions } from '@occc/graphql';

const categoryRestrictionItems = [
  { title: 'None', value: 'None' },
  { title: 'Age', value: Category_Restrictions.Age },
  { title: 'EAIV', value: Category_Restrictions.Eaiv },
];

export const FormContent: React.FC = () => {
  return (
    <>
      <TextField name='name' label='Name' margin='normal' required />

      <TextField
        type='number'
        name='rank'
        label='Rank'
        margin='normal'
        fieldProps={{
          parse: parseNumber,
        }}
      />

      <Box mt={2}>
        <ToggleButtonGroupField
          name='categoryRestriction'
          buttons={categoryRestrictionItems}
          label='Restriction'
        />
      </Box>
    </>
  );
};
